
export default {
  name: 'WishlistIcon',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggle () {
      /**
       * Emit toggle event to parent
       */
      this.$emit('toggle')
    }
  }
}
